import { NavigateFunction } from 'react-router';

import { currentUserSliceActions } from './currentUserSlice';
import { getFingerPrint, parseUserRole, saveAccessToken } from '../../../../../helpers/utils/auth';
import {
    showErrorMessage,
    showSuccessNotification,
} from '../../../../../helpers/utils/ui';
import { profileApi } from '../../../../../shared/common/api/endpoints/profileApi';
import { schoolApi } from '../../../../../shared/common/api/endpoints/schoolApi';
import { staffApi } from '../../../../../shared/common/api/endpoints/staffApi';
import { handleResponseError } from '../../../../../shared/common/api/middleware';
import { routeNames } from '../../../../../shared/common/constants/routes';
import { TAppDispatch } from '../../store';
import { appActions } from '../app/actions';
import { currentSchoolActions } from '../currentSchool/actions';

export const currentUserActions = {
    ...currentUserSliceActions,

    fetchUserAndSchoolInfo:
    (navigate: NavigateFunction, onFinish?: () => void) =>
        (dispatch: TAppDispatch) => {
            dispatch(appActions.setAppLoading(true));
            dispatch(currentUserActions.userSetLoading(true));

            schoolApi
                .fetchAllData()
                .then((response) => {
                    if (response.status === 200) {
                        const data = response.data;
                        const schoolData = {
                            selectedSchool: data.selected_school || undefined,
                            schoolList: data.school_all || undefined,
                            userAccess: {
                                ...data.access,
                                telegram_connect: data.telegram_connect,
                                max_connect: !!data.max_connect,
                                messenger_connect: !!(data.messenger_connect ?? data.telegram_connect),
                                require_messenger: data.require_messenger ?? true,
                            },
                            tariff: data.tariff ?? { id: null, name: null },
                        };
                        dispatch(currentUserActions.setContact(data.contact));
                        dispatch(currentUserActions.setIsAdmin(!!data.setting));
                        if(schoolData.selectedSchool){
                            if(schoolData.selectedSchool?.id){
                                try{
                                    staffApi.getCurrentStaff(schoolData.selectedSchool?.id,data.id).then((response)=>{
                                        if (response.status === 200) {
                                            const newValues = Object.entries(response.data).map(([ key, val ]) => {
                                                if ((key === 'ads' || key === 'offers') && (val === null || val === undefined)) {
                                                    return { name: key, value: [] };
                                                }

                                                return { name: key, value: val };
                                            });

                                            if(newValues.some((element)=>element.name.includes('utm'))){
                                                dispatch(
                                                    currentUserActions.setUtm(true));
                                            }else{
                                                dispatch(
                                                    currentUserActions.setUtm(false));
                                            }
                                        }
                                    });
                                }catch(err){
                                    console.error(err);
                                }
                            }

                            const role = parseUserRole(data.role, data.setting, data.contact);

                            dispatch(
                                currentUserActions.currentUserSetData({
                                    id: data.id,
                                    name: data.name,
                                    email: data.email,
                                    phone: data.phone,
                                    role: role,
                                    global_role: data.global_role || '',
                                    school_id: data.school_id || null,
                                    isLoading: false,
                                    ownedSchool: data.owned_school ?? data.ownedSchool,
                                    telegram_connect: data.telegram_connect,
                                    max_connect: data.max_connect,
                                    messenger_connect: data.messenger_connect,
                                    require_messenger: data.require_messenger,
                                    main_dashboard: data.main_dashboard
                                })
                            );
                            dispatch(currentSchoolActions.currentSchoolSetData(schoolData));
                        }else{
                            const role = parseUserRole(data.role, data.setting, data.contact);

                            dispatch(
                                currentUserActions.currentUserSetData({
                                    id: data.id,
                                    name: data.name,
                                    email: data.email,
                                    phone: data.phone,
                                    role: role,
                                    global_role: data.global_role || '',
                                    school_id: data.school_id || null,
                                    isLoading: false,
                                    ownedSchool: data.owned_school ?? data.ownedSchool,
                                    telegram_connect: data.telegram_connect,
                                    max_connect: data.max_connect,
                                    messenger_connect: data.messenger_connect,
                                    require_messenger: data.require_messenger,
                                    main_dashboard: data.main_dashboard
                                })
                            );
                            dispatch(currentSchoolActions.currentSchoolSetData(schoolData));
                        }
                        onFinish && onFinish();
                    }
                })
                .catch((err) => {
                    handleResponseError(dispatch, err);
                })
                .finally(() => {
                    dispatch(appActions.setAppLoading(false));
                    dispatch(currentUserActions.userSetLoading(false));
                });
        },

    updateUserInfo:
    (values: any, onFinish?: () => void) => (dispatch: TAppDispatch) => {
        dispatch(currentUserActions.userSetLoading(true));

        profileApi
            .updateProfileData(values)
            .then((response) => {
                if (response.status === 200) {
                    showSuccessNotification('Данные обновлены.');
                    onFinish && onFinish();
                }
            })
            .catch(() => {
                showErrorMessage('Ошибка при обновлении данных.');
            })
            .finally(() => {
                dispatch(currentUserActions.userSetLoading(false));
            });
    },

    updateUserPassword:
    (values: any, onFinish?: () => void) => async (dispatch: TAppDispatch) => {
        dispatch(currentUserActions.userSetLoading(true));
        const fingerprint = await getFingerPrint();
        profileApi
            .changePassword({ ...values, fingerprint })
            .then((response) => {
                if (response.status === 200) {
                    showSuccessNotification('Пароль обновлен.');
                    onFinish && onFinish();
                }
                if(response.data?.access_token){
                    saveAccessToken(response.data.access_token);
                }
            })
            .catch(() => {
                showErrorMessage('Ошибка при обновлении данных.');
            })
            .finally(() => {
                dispatch(currentUserActions.userSetLoading(false));
            });
    },
};
